// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vCVC4YvzEL4OOPuRmKIf{flex-direction:column;gap:15px;display:flex}.auqKya2HPb4l_tuuxz4f{padding:16px 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `vCVC4YvzEL4OOPuRmKIf`,
	"titledRow": `auqKya2HPb4l_tuuxz4f`
};
export default ___CSS_LOADER_EXPORT___;
